import {UserRole, Permission, ROLE_PERMISSIONS} from '../constants/roles'
import {UserModel, TeamModuleSlug, TeamModulePermissions} from '../modules/auth/models/UserModel'

export const hasPermission = (user: UserModel | null, permission: Permission): boolean => {
  if (!user || !user.roles || user.roles.length === 0) return false

  return user.roles.some((role) => {
    const permissions = ROLE_PERMISSIONS[role as UserRole] || []
    return permissions.includes(permission)
  })
}

export const hasRole = (user: UserModel | null, role: UserRole): boolean => {
  if (!user || !user.roles) return false
  return user.roles.includes(role)
}

export const hasTeamModuleAction = (
  user: UserModel | null,
  moduleSlug: TeamModuleSlug,
  action: keyof TeamModulePermissions
): boolean => {
  if (!user || !user.isTeamMember) return false
  return !!user.teamPermissions?.[moduleSlug]?.[action]
}